import { findAncestorWithComponent } from "../utils/scene-graph";
AFRAME.registerComponent("artwork-frame", {
  schema: {
    model: { type: "string" },
    scaleX: { default: 1 },
    scaleY: { default: 1 },
    completed: { default: false }
  },
  init() {
    this.modelLoaded = false;
    this.el.addEventListener("model-loaded", this.onModelLoaded.bind(this));
  },
  update(oldData) {
    if (this.data.model !== oldData.model) {
      this.modelLoaded = false;
      this.el.removeAttribute("gltf-model-plus");

      if (this.data.model) {
        this.el.setAttribute("gltf-model-plus", { src: this.data.model });
        this.el.setAttribute("id", "frame");
        this.el.emit("load-start");
      }
    }
  },
  onModelLoaded(event) {
    this.updateSizeAndPosition();
  },
  updateSizeAndPosition() {
    const model = this.el.getObject3D("mesh");

    const width = this.data.scaleX;
    const height = this.data.scaleY;
    const offsetX = width * 0.5;
    const offsetY = height * 0.5;
    const cornerSize = 2.935;

    const target = new AFRAME.THREE.Vector3();
    if (!model) return;

    model.traverse(node => {
      if (!node.isMesh) {
        return;
      }

      const boundingBox = node.geometry.boundingBox.getSize(target);

      switch (node.name) {
        // Top left corner
        case "corner_top_left":
          node.position.set(-offsetX, offsetY, 0);
          node.visible = true;
          break;
        // Top right corner
        case "corner_top_right":
          node.position.set(offsetX, offsetY, 0);
          node.visible = true;
          break;
        // Bottom left corner
        case "corner_bottom_left":
          node.position.set(-offsetX, -offsetY, 0);
          node.visible = true;
          break;
        // Bottom right corner
        case "corner_bottom_right":
          node.position.set(offsetX, -offsetY, 0);
          node.visible = true;
          break;
        // Top
        case "center_top":
          node.position.set(0, offsetY, 0);
          node.scale.x = width / boundingBox.x - cornerSize;
          node.visible = true;
          break;
        // Left
        case "center_left":
          node.position.set(-offsetX, 0, 0);
          node.scale.y = height / boundingBox.y - cornerSize;
          node.visible = true;
          break;
        // Bottom
        case "center_bottom":
          node.position.set(0, -offsetY, 0);
          node.scale.x = width / boundingBox.x - cornerSize;
          node.visible = true;
          break;
        // Right
        case "center_right":
          node.position.set(offsetX, 0, 0);
          node.scale.y = height / boundingBox.y - cornerSize;
          node.visible = true;
          break;
      }

      // Duplicate the material because it's shared between the frame
      // pieces
      // Duplication of texture has been removed because it cause issues in
      // Metaverse GLTFLoader
      const material = node.material.clone();
      const texture = material.map;
      texture.anisotropy = 8;
      texture.colorSpace = THREE.SRGBColorSpace;
      texture.wrapS = THREE.RepeatWrapping;
      texture.wrapT = THREE.RepeatWrapping;
      texture.repeat.set(node.scale.x, node.scale.y);

      // Flip texture repeat values for vertical pieces
      if (["center_left", "center_right"].includes(node.name)) {
        texture.repeat.set(node.scale.y, node.scale.x);
      }

      texture.needsUpdate = true;
      material.map = texture;
      material.toneMapped = false;
      node.material = material;
    });
    model.position.set(0, 0, 0.008);

    this.updateQrCode();
  },
  createBoundingBoxFromObject(obj) {
    return new AFRAME.THREE.Box3().setFromObject(obj);
  },
  updateQrCode() {
    const artwork = findAncestorWithComponent(this.el, "artwork");
    const artworkComponent = artwork.components["artwork"].data;
    const artworkQr = this.el.parentEl.querySelector("[artwork-qr]");
    if (artworkQr) {
      const artworkQrData = {
        frame: this.data.model,
        glbModel: artworkComponent.glbModel,
        remoteArtwork: artworkComponent.remoteArtwork,
        image: artworkComponent.image,
        completed: this.data.completed,
        scaleX: this.data.scaleX,
        scaleY: this.data.scaleY
      };
      artworkQr.setAttribute("artwork-qr", artworkQrData);
    }
  }
});
